var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"centered-content"},[_c('h1',[_vm._v("404")]),_c('p',[_vm._v("Oops! Something is wrong.")]),_c('router-link',{staticClass:"router-link",attrs:{"to":"/"}},[_vm._v("Go Home")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }